import { combineReducers } from 'redux';
import fundDetails from './fundDetails';
import diy from './diy';
import mfOrders from './mfOrders';
import loader from './loader';
import actionLoader from './actionLoader';
import error from './error';
import nominee from './nominee';
import accountClosure from './accountClosure';
import referAndEarn from './referAndEarn';
import app from './app';
import portfolioV2 from './portfolioV2';
import helpAndSupport from './helpAndSupport';
import myAccount from './myAccount';
import ordersAuth from './ordersAuth';
import mfV2 from './mfV2';
import orderForm from './equity/orderForm';
import equityGlobal from './equity/equityGlobal';
import foDisclosure from './foDisclosure';
import actionError from './actionError';
import stocksPortfolio from './equity/stocksPortfolio';
import orderBook from './equity/orderBook';
import watchlist from './equity/watchlist';
import scripDetails from './equity/scripDetails/scripDetail';
import indices from './equity/indices';
import marketWatch from './equity/marketWatch';
import stockNews from './landing/stockLanding/stockNews';
import newsAndAnnouncements from './equity/newsAndAnnouncements';
import guestScripDetailV2 from './guestLoginV2';
import payment from "./payment";
import scripDetailsLookUpData from './equity/scripDetails/scripDetailsLookUpData';
import scripDetailsLoader from './equity/scripDetails/scripDetailsLoader';
import scripDetailsActionLoader from './equity/scripDetails/scripDetailsActionLoader';
import scripDetailsActionError from './equity/scripDetails/scripDetailsActionError';
import scripDetailsError from './equity/scripDetails/scripDetailsError';
import optionChainLookUpData from './equity/optionChain/optionChainLookUpData';
import optionChain from './equity/optionChain/optionChain';
import optionChainLoader from './equity/optionChain/optionChainLoader';
import paymentV2 from './paymentV2';
import mostBoughtStock from './equity/mostBoughtStock';
import withdrawFunds from './equity/funds/withdrawFunds';
import transactionHistory from './equity/funds/transactionHistory';
export const businessLogicReducers = {
	fundDetails,
	diy,
	mfOrders,
	nominee,
	accountClosure,
	referAndEarn,
	loader,
	actionLoader,
	error,
	app,
	portfolioV2,
	helpAndSupport,
	myAccount,
	ordersAuth,
	mfV2,
	orderForm,
	equityGlobal,
	actionError,
	foDisclosure,
	scripDetails,
	watchlist,
	orderBook,
	stocksPortfolio,
	indices,
	marketWatch,
	stockNews,
	newsAndAnnouncements,
	guestScripDetailV2,
	payment,
	scripDetailsLookUpData,
	scripDetailsLoader,
	scripDetailsActionLoader,
	scripDetailsActionError,
	scripDetailsError,
	optionChainLookUpData,
	optionChain,
	optionChainLoader,
	paymentV2,
	mostBoughtStock,
	withdrawFunds,
	transactionHistory,
};

export default combineReducers(businessLogicReducers);
